import {IntermediatePart} from "../../intermediatePart";

export default class IslandHood extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_island_hood';
    this.partName = 'Island Hood';
    this.translateId = "visualizer.kitchen.center_island.center_island_hood";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new IslandHood());
  }

  disabledClick() {
    const centerIslandParent = this.getParent();
    if (!this.disabled && centerIslandParent.cabinet) {
      centerIslandParent.cabinet.disabled = false;
      centerIslandParent.cabinet.disabledClick();
    } else {
      const stovetop = centerIslandParent.stovetop;
      if (stovetop && !this.disabled && stovetop.disabled) {
        stovetop.disabled = false;
      }
    }
  }

}
